import React, {Component} from 'react';
import { connect } from 'react-redux';
import {fetchEvent,updateEvent,openInterestModal,fetchUserInterests} from 'ActionsMessage';

class InterestTag extends Component  {

  editTag=(e)=>{
    this.props.openInterestModal(true,this.props.tag);
  }

  render(){
    var {tag} = this.props;
    return(
      <span className="interest-tag" onClick={this.editTag}>{tag.interest}</span>
    )
  }
}

export default connect(null,{openInterestModal})(InterestTag);
